import { OneSignal } from '@/modules/onesignal'
import { extendLogger, LoggerContexts } from '@/utils/logger'
import type { PushClickEvent, PushIdentity, PushPermissionStatus, Unsubscribe } from './push.types'

const logger = extendLogger(LoggerContexts.Push)

/**
 * Web stub for the push facade.
 *
 * Web push is switched off (PP-4542) and the Customer.io mobile SDK is native-only —
 * web profiles reach Customer.io through the Segment destination instead. The one
 * live behaviour kept here is the OneSignal web `login`, so an authenticated web
 * session still resolves to the same OneSignal profile it did before this refactor.
 *
 * Deep links on web are handled by the browser URL bar, not by a click listener.
 */

const noop: Unsubscribe = () => {}

export async function initializePush() {
  return
}

export async function identifyPush(identity: PushIdentity) {
  try {
    await OneSignal.login(identity.legacyUserId || identity.auth0Id)
  } catch (error) {
    logger.warn('OneSignal web login failed', error)
  }
}

export async function clearPushIdentity() {
  return
}

export async function setPushAttributes(_attributes: Record<string, string | undefined>) {
  return
}

export async function getPushPermission(): Promise<PushPermissionStatus> {
  return 'undetermined'
}

export async function isPushGranted() {
  return false
}

export async function requestPushPermission(_fallbackToSettings = true) {
  return
}

export async function optInPush() {
  return
}

export async function ensurePushEnabled(_enabled: boolean, _fallbackToSettings = true) {
  return
}

export async function syncPushToken(_token?: string | null) {
  return
}

export function addPushClickListener(_listener: (event: PushClickEvent) => void): Unsubscribe {
  return noop
}

export function addPushPermissionListener(_listener: (granted: boolean) => void): Unsubscribe {
  return noop
}

export const pushProviderIds: string[] = []
